import React, {Component} from 'react';

import ClassNames from 'classnames';
import {isFinite, isNaN} from 'lodash';
import PropTypes from 'prop-types';

import {basicShouldComponentUpdate} from '@/libs/reactHelper';

class NumBox extends Component {
  constructor(props) {
    super(props);
    this.state = {
      value: props.value,
    };
  }

  shouldComponentUpdate(nextProps, nextState) {
    const {value} = this.props;
    const {value: valueState} = this.state;
    if (JSON.stringify(nextProps.value) !== JSON.stringify(value)) {
      return true;
    }
    if (JSON.stringify(nextState.value) !== JSON.stringify(valueState)) {
      return true;
    }
    return basicShouldComponentUpdate(
      this.props,
      this.state,
      nextProps,
      nextState,
      ['value', 'readOnly', 'disabled', 'className'],
      ['style'],
      null,
    );
  }

  componentDidUpdate(prevProps) {
    const {value} = this.props;

    if (value !== prevProps.value) {
      this.setStateValue({value});
    }
  }

  // eslint-disable-next-line class-methods-use-this
  isNumeric = (n) => !isNaN(parseFloat(n)) && isFinite(parseFloat(n));

  // eslint-disable-next-line class-methods-use-this
  getPrecision = (a) => {
    if (!isFinite(a)) return 0;

    let e = 1;
    let p = 0;

    while (Math.round(a * e) / e !== a) {
      e *= 10;
      p++;
    }

    return p;
  };

  // eslint-disable-next-line class-methods-use-this
  getLengthUnderComma = (val, index) => {
    const v = `${val}`;
    if (v.indexOf('.') === -1) {
      return 0;
    }
    const arr = v.split('.')[index];
    return arr.length;
  };

  valueChangeHandler = (e) => {
    const {precision, signed} = this.props;
    const {valueState} = this.state;
    let newValue = e.target.value;

    const oldValue = valueState;

    if (newValue === '') {
      this.setStateValue({value: newValue});
      return newValue;
    }

    if (newValue === '.' && precision !== 0) {
      newValue = `${this.setMinMaxValue('0')}.`;
    }

    if (!isNaN(`${newValue}`[0]) && `${newValue}`[1] === '.' && newValue.length === 2 && precision !== 0) {
      this.setStateValue({value: newValue});
      return newValue;
    }

    if (
      !isNaN(`${newValue}`[0]) &&
      `${newValue}`[1] === '.' &&
      !isNaN(`${newValue}`[2]) &&
      newValue.length === 3 &&
      precision !== 0
    ) {
      this.setStateValue({value: newValue});
      return newValue;
    }

    if (`${newValue}` === '-' || `${newValue}` === '0.00') {
      this.setStateValue({value: newValue});
      return newValue;
    }

    if (signed && newValue === '-') {
      this.setStateValue({value: newValue});
      return newValue;
    }

    if (!this.isNumeric(newValue)) newValue = oldValue;

    if (precision !== null) {
      if (precision <= 0) {
        newValue = newValue.replace('.', '');
      } else if (this.getPrecision(parseFloat(newValue)) > precision) {
        newValue = oldValue;
      }
    }

    if (newValue.length > 1 && `${newValue[newValue.length - 1]}` === '0') {
      newValue = newValue.replace(/^0+/, '');

      if (newValue === '') newValue = 0;
    }

    if (`${newValue}`[0] === '.' && precision !== 0) {
      newValue = `0${newValue}`;
    }

    if (parseFloat(newValue) === 0 && this.getLengthUnderComma(newValue, 1) > precision) {
      newValue = oldValue;
    }

    this.setStateValue({value: newValue});

    return newValue;
  };

  setStateValue = (val) => {
    const newValue = this.setMinMaxValue(val.value);
    this.setState({value: newValue});
  };

  setMinMaxValue = (val) => {
    const {min, max, precision} = this.props;
    let newValue = val;

    if (!isNaN(`${newValue}`[0]) && `${newValue}`[1] === '.' && newValue.length === 2 && precision !== 0) {
      newValue = `${this.setMinMaxValue(newValue[0])}.`;
      return newValue;
    }
    if (!isNaN(parseFloat(newValue)) && min && parseFloat(newValue) <= min) {
      newValue = min;
    }
    if (!isNaN(parseFloat(newValue)) && max && parseFloat(newValue) >= max) {
      newValue = max;
    }
    return newValue;
  };

  onChange = (e) => {
    const {onChange} = this.props;
    let newValue = this.valueChangeHandler(e);
    newValue = this.setMinMaxValue(newValue);
    if (!onChange) return;
    onChange(newValue, e);
  };

  onClick = (e) => {
    const {onClick} = this.props;
    let newValue = this.valueChangeHandler(e);
    newValue = this.setMinMaxValue(newValue);
    if (!onClick) return;
    onClick(newValue, e);
  };

  onBlur = () => {
    const {min, onBlur} = this.props;
    const {value} = this.state;
    let newValue = value; // this.valueChangeHandler(e);
    newValue = this.setMinMaxValue(newValue);
    if (min && newValue.length === 0) {
      newValue = this.setMinMaxValue(min);
    }
    this.setStateValue({value: newValue});

    if (!onBlur) return;

    onBlur(newValue);
  };

  onKeyUp = (e) => {
    const {onKeyUp} = this.props;
    const {value} = this.state;
    if (e.keyCode !== 13) return;

    const newValue = value; // this.valueChangeHandler(e);

    if (!onKeyUp) return;

    onKeyUp(newValue);
  };

  onFocus = (event) => {
    const {onFocus} = this.props;
    onFocus(event);
    event.target.select();
  };

  render() {
    const {className, maxLength, style, placeholder, readOnly, disabled} = this.props;
    const {value} = this.state;
    let props = {};
    if (maxLength) {
      props = {
        ...props,
        maxLength,
      };
    }
    return (
      <input
        // eslint-disable-next-line react/jsx-props-no-spreading
        {...props}
        className={ClassNames('inputField ', className)}
        style={style}
        type="text"
        placeholder={placeholder}
        value={value}
        onChange={this.onChange}
        onBlur={this.onBlur}
        onKeyUp={this.onKeyUp}
        readOnly={readOnly}
        onFocus={this.onFocus}
        disabled={disabled}
        onClick={this.onClick}
      />
    );
  }
}

NumBox.propTypes = {
  onKeyUp: PropTypes.func,
  onBlur: PropTypes.func,
  onChange: PropTypes.func,
  onFocus: PropTypes.func,
  precision: PropTypes.number,
  maxLength: PropTypes.number,
  style: PropTypes.object,
  value: PropTypes.string,
  placeholder: PropTypes.string,
  readOnly: PropTypes.bool,
  signed: PropTypes.bool,
  disabled: PropTypes.bool,
  className: PropTypes.any,
  max: PropTypes.any,
  min: PropTypes.any,
  onClick: PropTypes.func,
};

NumBox.defaultProps = {
  value: '',
  placeholder: 'Not set',
  className: null,
  onBlur: () => {},
  onKeyUp: () => {},
  onFocus: () => {},
  onChange: () => {},
  readOnly: false,
  signed: false,
  disabled: false,
  precision: 3,
  maxLength: null,
  max: null,
  min: null,
  style: {},
  onClick: () => {},
};

export default NumBox;
